<template>
  <main class="home-page">
    <HeroSection />
    <PortfolioSection />
    <AboutSection />
    <ContactSection />
  </main>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue';
import PortfolioSection from '@/components/PortfolioSection.vue';
import AboutSection from '@/components/AboutSection.vue';
import ContactSection from '@/components/ContactSection.vue';

export default {
  name: 'HomePage',
  components: {
    HeroSection,
    PortfolioSection,
    AboutSection,
    ContactSection
  }
};
</script>
  